<template>
    <v-app>
        <!--
            Deliberately not a <v-tooltip>. One shared v-tooltip whose
            :activator is swapped as the cursor moves stops reopening after the
            first item: VTooltip measures and shows its activator inside
            activate(), which only runs on the closed -> open edge, and its own
            openOnHover listeners are bound to an element the cursor has already
            entered. Verified in a browser before rewriting it this way.

            This is the same markup Vuetify renders, positioned directly, so it
            looks identical and answers to nothing but the handler below.
        -->
        <div v-show="sidebarTipOpen" class="v-tooltip__content sidebar-tip" :style="sidebarTipStyle">
            {{ sidebarTipText }}
        </div>

        <v-navigation-drawer v-model="drawer" app clipped temporary
            @mouseover.native="onSidebarHover" @mouseleave.native="hideSidebarTooltip">
            <router-link to="/" class="white--text" style="text-decoration: none">
                <v-img class="mx-10 mt-5 env-logo" src="../images/rcms_logo.svg"></v-img>
            </router-link>
            <v-list nav dense expand>
                <v-list-item-group active-class="primary--text">
                    <v-subheader v-if="
                        $gate.can('View Dashboard Analytics') ||
                        $gate.can('Report 60') ||
                        $gate.can('Summary Collection') ||
                        $gate.can('Summary of Collection Per Account') ||
                        $gate.can('Summary of Main Accounts') ||
                        $gate.can('GF-RCD/TRUST/SEF') ||
                        $gate.can('RCD') ||
                        $gate.can('Real Property Tax Collection') ||
                        $gate.can('Advance Real Property Tax Collection') ||
                        $gate.can('Barangay Shares') ||
                        $gate.can('Advance Barangay Shares') ||
                        $gate.can('Report on RPT (Basic / SEF)') ||
                        $gate.can('RGR') ||
                        $gate.can('RAAF') ||
                        $gate.can('RAAF (Amount and Cancelled OR)') ||
                        $gate.can('CRAAF') ||
                        $gate.can('OR Acceptance') ||
                        $gate.can('Abstract') ||
                        $gate.can('Inquiry') ||
                        $gate.can('View Report History List') ||
                        $gate.can('View RCD List') ||
                        $gate.can('View Own RCD List') ||
                        $gate.can('View Online Payments')
                    ">
                        ANALYTICS
                    </v-subheader>

                    <v-list-item v-if="$gate.can('View Dashboard Analytics')" to="/">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-tablet-dashboard
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Dashboard</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group v-if="
                        $gate.can('Report 60') ||
                        $gate.can('Summary Collection') ||
                        $gate.can('Summary of Collection Per Account') ||
                        $gate.can('Summary of Main Accounts') ||
                        $gate.can('GF-RCD/TRUST/SEF') ||
                        $gate.can('RCD') ||
                        $gate.can('Real Property Tax Collection') ||
                        $gate.can('Advance Real Property Tax Collection') ||
                        $gate.can('Barangay Shares') ||
                        $gate.can('Advance Barangay Shares') ||
                        $gate.can('Report on RPT (Basic / SEF)') ||
                        $gate.can('View Report History List') ||
                        $gate.can('View RCD List') ||
                        $gate.can('View Own RCD List') ||
                        $gate.can('RGR') ||
                        $gate.can('RAAF') ||
                        $gate.can('RAAF (Amount and Cancelled OR)') ||
                        $gate.can('CRAAF') ||
                        $gate.can('OR Acceptance') ||
                        $gate.can('Abstract') ||
                        $gate.can('View Online Payments') ||
                        $gate.can('CSM Report')
                    ">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-file-document-multiple-outline
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Reports</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-if="
                            $gate.can('Report 60') ||
                            $gate.can('Summary Collection') ||
                            $gate.can(
                                'Summary of Collection Per Account'
                            ) ||
                            $gate.can('Summary of Main Accounts') ||
                            $gate.can('GF-RCD/TRUST/SEF') ||
                            $gate.can('RCD') ||
                            $gate.can('RGR') ||
                            $gate.can('RAAF') ||
                            $gate.can('RAAF (Amount and Cancelled OR)') ||
                            $gate.can('CRAAF') ||
                            $gate.can('OR Acceptance') ||
                            $gate.can('Abstract')
                        " class="pl-7" to="/gen-summ">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-all-inclusive
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Collections
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="
                            $gate.can('Real Property Tax Collection') ||
                            $gate.can(
                                'Advance Real Property Tax Collection'
                            ) ||
                            $gate.can('Barangay Shares') ||
                            $gate.can('Advance Barangay Shares') ||
                            $gate.can('Report on RPT (Basic / SEF)')
                        " class="pl-7" to="/rpt">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-map-legend</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>RPT</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>


                        <v-list-item v-if="$gate.can('View RCD List') || $gate.can('View Own RCD List')" class="pl-7" to="/report-rcd">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-book-account-outline</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>RCD List</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="$gate.can('View Report History List')" class="pl-7" to="/report-history">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-history</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>History</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="$gate.can('View Online Payments')" class="pl-7" to="/online-payments">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-cash-multiple
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Online Payments</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="$gate.can('CSM Report')" class="pl-7" to="/csm-scope">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-clipboard-check-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>CSM Report</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item v-if="$gate.can('Inquiry') || $gate.can('Cashier Collections')" to="/inquiry">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-clipboard-list-outline
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Inquiry</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-subheader v-if="
                        $gate.can('RPT Data Sync') ||
                        $gate.can('View Transaction List') ||
                        $gate.can('Create Transaction') ||
                        $gate.can('CTC Individual') ||
                        $gate.can('CTC Corporation') ||
                        $gate.can('Encoding') ||
                        $gate.can('View SHT List') ||
                        $gate.can('View CTC List') ||
                        $gate.can('View Report 60 List') ||
                        $gate.can('View Collection Names') ||
                        $gate.can('View GF-RCD/TRUST/SEF List') ||
                        $gate.can('View Main Account List') ||
                        $gate.can('View Summary of Collection List') ||
                        $gate.can('View Employee List') ||
                        $gate.can('View Cancelled OR List') ||
                        $gate.can('View OR List') ||
                        $gate.can('View Barangay List') ||
                        $gate.can('View User List') ||
                        $gate.can('View Log List') ||
                        $gate.can('View Department List') ||
                        $gate.can('View Holidays') ||
                        $gate.can('Check Payment') ||
                        $gate.can('View Remittance') ||
                        $gate.can('View Remittance Admin') ||
                        $gate.can(
                            'View Summary of Collections Per Account'
                        ) ||
                        $gate.can('View Cancelled OR List Admin') ||
                        $gate.can('View OR Swapping') ||
                        $gate.can('View OR Swapping Admin') ||
                        $gate.can('View Held OR List') ||
                        $gate.can('View Held OR List Admin') ||
                        $gate.can('Tax Order Payment') ||
                        $gate.can('Settings')
                    ">
                        APPLICATIONS
                    </v-subheader>

                    <v-list-group v-if="
                        $gate.can('Create Transaction') ||
                        $gate.can('CTC Individual') ||
                        $gate.can('CTC Corporation') ||
                        $gate.can('View SHT List') ||
                        $gate.can('View CTC List') ||
                        $gate.can('Check Payment') ||
                        $gate.can('Tax Order Payment') ||
                        $gate.can('Encoding')
                    ">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-cash-multiple
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Payment</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item class="pl-7" v-if="$gate.can('Tax Order Payment')" to="/payment-order">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cash</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Tax Order Payment
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="pl-7" v-if="$gate.can('Create Transaction')" to="/cashier">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cash</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Create Payment
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="pl-7" v-if="$gate.can('CTC Individual')" to="/ctc-ind">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cash</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    CTC Individual
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="pl-7" v-if="$gate.can('CTC Corporation')" to="/ctc-corp">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cash</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    CTC Corporation
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="pl-7" v-if="$gate.can('Check Payment')" to="/check">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cash</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Check Payment
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="pl-7" v-if="$gate.can('Encoding')" to="/multi-payment">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-cash-multiple
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Encoding
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-group v-if="
                            $gate.can('View SHT List') ||
                            $gate.can('View CTC List')
                        ">
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-icon color="primary" class="pl-5">
                                        mdi-map-legend
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>RPT</v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-list-item class="pl-12" v-if="$gate.can('View SHT List')" to="/sht-list">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-cash-marker
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>SHT</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item class="pl-12" v-if="$gate.can('View CTC List')" to="/ctc-list">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-cash-marker
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>CTC</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                        <v-list-item class="pl-7" v-if="$gate.can('View BPLO List')" to="/bplo-list">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-storefront</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>BPLO</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group v-if="
                        $gate.can('View Transaction List') ||
                        $gate.can('View Transaction List Admin') ||
                        $gate.can('View Encoded Transaction List') ||
                        $gate.can('View Encoded Transaction List Admin')
                    ">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-bank-transfer
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Transactions
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item class="pl-7" v-if="
                            $gate.can('View Transaction List') ||
                            $gate.can('View Transaction List Admin')
                        " to="/trans">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-clipboard-text-outline
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Single Transactions
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="
                            $gate.can('View Encoded Transaction List') ||
                            $gate.can('View Encoded Transaction List Admin')
                        " to="/Encoded-trans">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-clipboard-text-multiple-outline
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Encoded Transactions
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item v-if="
                        $gate.can('View Transaction List') ||
                        $gate.can('View Transaction List Admin')" to="/check-list">
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-bank-check</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Check List</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>


                    <v-list-item v-if="
                        $gate.can('View Remittance') ||
                        $gate.can('View Remittance Admin')
                    " to="/remittance">
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-calendar-range</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Remittance</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="
                        $gate.can('View OR Swapping') ||
                        $gate.can('View OR Swapping Admin')
                    " to="/or-swapping">
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-swap-horizontal</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>OR Swapping</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="
                        $gate.can('View Cancelled OR List') ||
                        $gate.can('View Cancelled OR List Admin')
                    " to="/cancelled-or">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-file-document-remove-outline
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Cancelled OR</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="
                        $gate.can('Request Payment Adjustment') ||
                        $gate.can('Approve Payment Adjustment')
                    " to="/payment-adjustments">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-cash-sync
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Online Payment Adjustments</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="$gate.can('Manage Failed Jobs')" to="/failed-jobs">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-alert-octagon-outline
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Undelivered Payment Notifications</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="
                        $gate.can('View Held OR List') ||
                        $gate.can('View Held OR List Admin')
                    " to="/held-or">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-pause-circle-outline
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Held OR</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group v-if="
                        $gate.can('View OR List') ||
                        $gate.can('View Report 60 List') ||
                        $gate.can('View Collection Names') ||
                        $gate.can('View GF-RCD/TRUST/SEF List') ||
                        $gate.can('View Main Account List') ||
                        $gate.can('View Summary of Collection List') ||
                        $gate.can('View Department List') ||
                        $gate.can('View Barangay List') ||
                        $gate.can('View Employee List') ||
                        $gate.can('View User List') ||
                        $gate.can('View Role List') ||
                        $gate.can('View Holidays') ||
                        $gate.can('View Summary of Collections Per Account') ||
                        $gate.can('View CSM Service List') ||
                        $gate.can('Settings')
                    ">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-apps</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Management
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-group v-if="
                            $gate.can('View Report 60 List') ||
                            $gate.can('View Collection Names') ||
                            $gate.can('View GF-RCD/TRUST/SEF List') ||
                            $gate.can('View Main Account List') ||
                            $gate.can('View Summary of Collection List') ||
                            $gate.can(
                                'View Summary of Collections Per Account'
                            ) ||
                            $gate.can('View CSM Service List')
                        ">
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-icon color="primary" class="pl-5">
                                        mdi-format-list-text
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Collections
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-list-item v-if="$gate.can('View Collection Names')" class="pl-12" to="/coll-accts">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-bulleted-square
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Collection Accounts
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="$gate.can('View Report 60 List')" class="pl-12" to="/nature-of-tax">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-group
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Report 60
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="
                                $gate.can(
                                    'View Summary of Collections Per Account'
                                )
                            " class="pl-12" to="/summ-of-coll-per-acct">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-group
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Summary of Collections Per
                                        Account
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="
                                $gate.can('View Summary of Collection List')
                            " class="pl-12" to="/summ-of-coll">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-group
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Summary of Collections/Revenue
                                        Generated Report
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="$gate.can('View Main Account List')" class="pl-12" to="/main-accounts">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-group
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Summary of Main Accounts
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="$gate.can('View GF-RCD/TRUST/SEF List')" class="pl-12"
                                to="/gf-rcd-trust-sef">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-format-list-group
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        GF/SEF/TRUST
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                             <v-list-item v-if="$gate.can('View CSM Service List')" class="pl-12" to="/csm-services">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-clipboard-list-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>CSM Services</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>

                        <v-list-item class="pl-7" v-if="$gate.can('View OR List')" to="/or">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-script-text-outline
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>
                                    Official Receipts
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View Department List')" to="/department-list">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-lan</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>
                                    Department/Transaction Type
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View Barangay List')" to="/brgys">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-map-legend</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Barangays</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>


                        <v-list-item class="pl-7" v-if="$gate.can('View Employee List')" to="/employees">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-account-group
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Employees</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View User List')" to="/user-mgt">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-account-group-outline
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Users</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View Role List')" to="/roles-permissions">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-shield-account-outline
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>
                                    Roles and Permissions
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View Holidays')" to="/holidays">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-calendar-multiselect
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Holidays</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('View Announcements')" to="/announcements">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-bullhorn-outline
                                </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Announcements</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="pl-7" v-if="$gate.can('Settings')" to="/settings">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-cog</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Settings</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>

                    <!-- Data Sync temporarily disabled
                    <v-list-group v-if="$gate.can('RPT Data Sync')">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    mdi-database-sync
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Data Sync</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-if="$gate.can('RPT Data Sync')" class="pl-7" to="/rpt-data-matching">
                            <v-list-item-icon>
                                <v-icon color="primary">mdi-land-fields</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>RPT</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    -->

                    <v-list-item v-if="$gate.can('View Log List')" to="/logs">
                        <v-list-item-icon>
                            <v-icon color="primary">
                                mdi-file-document-edit-outline
                            </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Logs</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar color="primary" app clipped dark>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="
                $gate.can('View Dashboard Analytics') ||
                $gate.can('Report 60') ||
                $gate.can('Summary Collection') ||
                $gate.can('Summary of Collection Per Account') ||
                $gate.can('Summary of Main Accounts') ||
                $gate.can('GF-RCD/TRUST/SEF') ||
                $gate.can('RCD') ||
                $gate.can('RGR') ||
                $gate.can('RAAF') ||
                $gate.can('RAAF (Amount and Cancelled OR)') ||
                $gate.can('CRAAF') ||
                $gate.can('OR Acceptance') ||
                $gate.can('Real Property Tax Collection') ||
                $gate.can('Advance Real Property Tax Collection') ||
                $gate.can('Barangay Shares') ||
                $gate.can('Advance Barangay Shares') ||
                $gate.can('Report on RPT (Basic / SEF)') ||
                $gate.can('RPT Data Sync') ||
                $gate.can('View Transaction List') ||
                $gate.can('Create Transaction') ||
                $gate.can('Encoding') ||
                $gate.can('View SHT List') ||
                $gate.can('View CTC List') ||
                $gate.can('View Report 60 List') ||
                $gate.can('View Collection Names') ||
                $gate.can('View GF-RCD/TRUST/SEF List') ||
                $gate.can('View Main Account List') ||
                $gate.can('View Summary of Collection List') ||
                $gate.can('View Employee List') ||
                $gate.can('View Cancelled OR List') ||
                $gate.can('View OR List') ||
                $gate.can('View Barangay List') ||
                $gate.can('View User List') ||
                $gate.can('View Log List') ||
                $gate.can('View Department List') ||
                $gate.can('View Holidays') ||
                $gate.can('View Report History List') ||
                $gate.can('Check Payment') ||
                $gate.can('View Summary of Collections Per Account') ||
                $gate.can('RGR') ||
                $gate.can('View Encoded Transaction List') ||
                $gate.can('View Encoded Transaction List Admin') ||
                $gate.can('View Transaction List Admin') ||
                $gate.can('CTC Individual') ||
                $gate.can('CTC Corporation') ||
                $gate.can('View BPLO List') ||
                $gate.can('View Remittance') ||
                $gate.can('View Remittance Admin') ||
                $gate.can('View Cancelled OR List Admin') ||
                $gate.can('Abstract') ||
                $gate.can('View OR Swapping') ||
                $gate.can('View OR Swapping Admin') ||
                $gate.can('View Held OR List') ||
                $gate.can('View Held OR List Admin') ||
                $gate.can('Tax Order Payment') ||
                $gate.can('Settings')
            "></v-app-bar-nav-icon>
            <v-toolbar-title>
                Revenue Collection Management System (RCMS)
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="mr-1" v-bind="attrs" v-on="on" @click="darkMode = !darkMode">
                        <v-icon>{{ darkMode ? 'mdi-weather-night' : 'mdi-white-balance-sunny' }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ darkMode ? 'Switch to Light Mode' : 'Switch to Night Mode' }}</span>
            </v-tooltip>

            <notif v-if="$gate.can('Notifications')"></notif>

            <v-menu offset-y :close-on-content-click="closeOnClick">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-1">
                        <v-avatar color="white" size="40">
                            <span class="primary--text text-h5 text-capitalize">
                                {{ name[0] }}
                            </span>
                        </v-avatar>
                    </v-btn>
                </template>
                <v-card class="text-center p-2">
                    <v-avatar color="primary" class="mt-3" size="78">
                        <span class="white--text text-h3 text-capitalize">
                            {{ name[0] }}
                        </span>
                    </v-avatar>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 text-capitalize">
                                    {{ name }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-capitalize">
                                    {{ role }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-btn class="mb-3" color="primary" small @click="
                                    route('/profile'), (closeOnClick = true)
                                    ">
                                    Manage Account
                                </v-btn>
                                <v-btn color="secondary" dark small @click="logout" :loading="loading">
                                    Logout
                                </v-btn>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>

        <v-main>
            <!--
                Inside v-main, not above the toolbar. v-app-bar is `app`, so it
                is position:fixed and paints over anything earlier in the flow:
                the banner rendered but sat underneath it, and its close button
                could not be clicked. Here it is the first thing under the
                toolbar on every page, which is what was wanted anyway.
            -->
            <announcement-banner></announcement-banner>

            <v-container fluid>
                <router-view></router-view>
                <snackbar :global="true" ref="sysAlert"></snackbar>
                <notifyAlert ref="sysnotifyAlert"></notifyAlert>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import darkMode from '../mixins/darkMode'
import { disable as disablePush } from '../push'
import AnnouncementBanner from './announcements/announcementBanner.vue'

export default {
    mixins: [darkMode],

    components: {
        AnnouncementBanner
    },

    data: () => ({
        loading: false,
        // Set once the force-logout message arrives, so a repeat broadcast
        // cannot restart the countdown or stack a second redirect.
        forcedOut: false,
        closeOnClick: false,
        drawer: false,
        role: window.user.role,
        name: window.name,
        text: '',

        // One tooltip serves the whole sidebar; these place it beside whichever
        // truncated item is under the cursor.
        sidebarTipOpen: false,
        sidebarTipText: '',
        sidebarTipStyle: {}
    }),

    methods: {
        /**
         * Show the full label when, and only when, the sidebar has cut it off.
         *
         * Vuetify already puts `text-overflow: ellipsis` and `white-space:
         * nowrap` on these titles, so scrollWidth exceeding clientWidth is an
         * exact answer to "did this get cut off". That beats guessing a
         * character count: the drawer has three indent levels, so the same
         * label fits at one level and not at another.
         *
         * Measured on hover rather than up front. By then the element is
         * certainly visible and laid out, which a pass at drawer-open time
         * cannot promise while the drawer is still sliding in, and it needs no
         * separate handling for groups that only render their children once
         * expanded.
         *
         * One listener and one tooltip for the whole menu. Wrapping each item
         * individually is what left six items with a tooltip and the longest
         * label in the menu without one.
         */
        onSidebarHover(event) {
            // Resolve the row first, then its label. The label is only one
            // line tall inside a taller row, so a cursor in the padding above
            // or below the text sits on the row, not on the label. Asking
            // closest('.v-list-item__title') directly finds nothing there and
            // the tooltip never appears, which is exactly what hovering these
            // items feels like.
            const row = event.target.closest('.v-list-item')
            const el = row ? row.querySelector('.v-list-item__title') : null

            // Collapse the whitespace, do not just trim it. Two labels are
            // written across two source lines, so their textContent carries a
            // newline and the file's indentation in the middle. Trimming alone
            // leaves that intact and the tooltip renders the label broken in
            // half with a gap.
            const label = el ? el.textContent.replace(/\s+/g, ' ').trim() : ''

            // Hiding on anything that is not a truncated title matters as much
            // as showing. mouseover fires on every element the cursor crosses,
            // so returning early on the icon or the gap between items would
            // leave the previous item's tooltip hanging there.
            if (!el || !label || !this.isTruncated(el)) {
                this.hideSidebarTooltip()
                return
            }

            // Fixed positioning against the item's own box, recomputed on every
            // hover, so the tooltip cannot drift onto a previously hovered row.
            const box = el.getBoundingClientRect()

            this.sidebarTipText = label

            // No display in here. v-show owns this element's display, and a
            // display in the binding quietly takes it back: v-show writes none
            // on hide, and then the next render of this component re-applies
            // the binding and puts the tooltip back on screen — by which point
            // the drawer it belonged to can be gone, leaving nothing on screen
            // to hover away from and no way to dismiss it. Closing the drawer
            // by clicking beside it does exactly that, in exactly that order:
            // the cursor leaves the drawer and hides the tooltip, then the
            // click closes the drawer and the re-render brings it back.
            // position: fixed already shrink-wraps the box to its text.
            this.sidebarTipStyle = {
                position: 'fixed',
                left: Math.round(box.right + 12) + 'px',
                top: Math.round(box.top + box.height / 2) + 'px',
                transform: 'translateY(-50%)',
                opacity: 0.9,
                pointerEvents: 'none',
                zIndex: 12
            }
            this.sidebarTipOpen = true
        },

        /**
         * Does the browser have to cut this label off to fit it?
         *
         * Measures the text itself with a Range rather than comparing the
         * label's scrollWidth to its clientWidth. Those two are rounded to
         * whole pixels and describe the box, not the text, so they report
         * "fits" for an overflow under a pixel — and they say nothing at all
         * when it is an ancestor doing the clipping rather than the label.
         * Either way an ellipsis appears on screen with no tooltip behind it.
         *
         * The half-pixel margin keeps a label that fits exactly from flickering
         * a tooltip on sub-pixel layout noise.
         */
        isTruncated(el) {
            const range = document.createRange()
            range.selectNodeContents(el)

            const textWidth = range.getBoundingClientRect().width
            const boxWidth = el.getBoundingClientRect().width

            range.detach()

            // Either signal is enough. The Range catches a sub-pixel overflow
            // and an ancestor doing the clipping; the width pair catches the
            // case where a browser clips the Range's own rect to the visible
            // box and so reports the text as narrower than it is. Missing a
            // tooltip is the failure that matters here, not showing a spare
            // one, so this asks both and takes either answer.
            return textWidth > boxWidth || el.scrollWidth > el.clientWidth
        },

        hideSidebarTooltip() {
            this.sidebarTipOpen = false
        },

        async logout() {
            this.loading = true
            // Drop this device's push subscription first, so a shared
            // workstation does not keep receiving this user's notifications.
            //
            // Bounded: unsubscribe() contacts the browser's push service, and
            // on an LGU network that blackholes it the promise can hang. Logging
            // out must never depend on a third party being reachable, so give
            // it two seconds and proceed either way.
            await Promise.race([
                disablePush(),
                new Promise((resolve) => setTimeout(resolve, 2000))
            ])
            axios.post('/logout').then((response) => {
                this.loading = false
            })
        },

        route(route) {
            this.$router.push(route).catch(() => { })
        },

        employeeBondStat() {
            axios
                .get('/employee-bond-status')
                .then((res) => {
                    this.cashier_id = res.data.id
                })
                .catch((err) => { })
        }
    },

    mounted() {
        this.employeeBondStat()

        Echo.private(`login.${window.awe}`).listen(
            '.login.attempt',
            (e) => {
                this.$refs.sysnotifyAlert.content({
                    content: e.message,
                    snackbar: true
                })
            }
        )

        // Someone ended this session from elsewhere, through the emailed logout
        // link or the admin screen. The session is already gone on the server,
        // so this tab would otherwise sit here looking alive and fail on every
        // click. Say why, then leave.
        Echo.private(`login.${window.awe}`).listen(
            '.force.logout',
            (e) => {
                if (this.forcedOut) return
                this.forcedOut = true

                this.$refs.sysAlert.content({
                    text: e.message,
                    snackbar: true,
                    icon: 'mdi-logout',
                    timeout: -1
                })

                // window.location, not vue-router and not axios. The session is
                // dead, so any request fails, and only a real page load clears
                // what this tab still holds in memory.
                setTimeout(() => {
                    window.location = '/login'
                }, 5000)
            }
        )

        // The in-app toast for bell notifications is gone: the OS notification
        // now covers the same events, and showing both meant every transaction
        // announced itself twice. notif.vue still listens on these channels to
        // update the bell list and play the sound.
        //
        // The login-attempt toast above stays. It is a security warning, it is
        // broadcast directly rather than through SendNotifJob, and push does
        // not carry it.

        window.addEventListener('offline', (e) => {
            this.$refs.sysAlert.content({
                text: 'You are currently offline.',
                snackbar: true,
                icon: 'mdi-wifi-strength-off'
            })
        })

        window.addEventListener('online', (e) => {
            this.$refs.sysAlert.content({
                text: 'Your internet connection was restored.',
                snackbar: true,
                icon: 'mdi-wifi',
                timeout: 2000
            })
        })
    }
}
</script>
